
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import CityListGird from '../components/CityListGird/index.vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import { Observer } from 'mobx-vue'
import type { ClickEvent } from '@xt/client/types/home'
import ConfirmModal from '../components/ConfirmModal/index.vue'
import type { ModalDataType, ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { EnumJoinResponseType } from '@xt/client/entities/kindred-spirit/guild'

@Observer
@Component({
  components: {
    NewSwiper,
    CityListGird,
    ConfirmModal
  },
  async asyncData(ctx) {
    await ctx.store.$tonghao.loadJSON()

    let hasJoin: boolean = false

    if (ctx.store.$storeUser.UserInfo.id) {
      hasJoin = await ctx.store.$tonghao.Guild.getHasJoinedCity()
    }

    return {
      hasJoin
    }
  }
})
export default class CityListPage extends Mixins(MixinsHomeClick) {
  hasJoin: boolean

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => Promise<boolean>
    hide: () => void
  }

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  get TonghaoStore() {
    return this.$store.$tonghao
  }

  get PageStore() {
    return this.$store.$tonghao.Guild
  }

  onJoinFail() {
    this.confirmModal.show({
      title: `还不能加入哦~`,
      description: '仅限报名过林曦老师亲授的直播课程，或是林曦老师监制的教练日课的桐学方可申请加入。',
      layoutClassName: 'join-fail-confirm-modal',
      confirmedHide: true,
      confirmText: '确认',
      hideCancel: true
    })
  }

  onJoinSuccess(guildId: number) {
    this.$msg('加入成功~', 'success')

    this.$router.push({
      path: `/topic/city/${guildId}`
    })
  }
  async openAssistantModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `为${data.cityName}分桐助力`,
      description: `助力成功后将自动加入${data.cityName}分桐，我们会选取热力值最高的1-2个城市，优先推动分桐开放。`,
      layoutClassName: 'assistant-confirm-modal',
      confirmedHide: true,
      confirmText: '立即助力',
      cancelText: '稍后再说',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png'
    })
    if (res === true) {
      const res = await this.PageStore.joinGuild(data.id)
      if (res === EnumJoinResponseType.Success) {
        this.onJoinSuccess(data.id)
      } else if (res === EnumJoinResponseType.NoAuth) {
        this.onJoinFail()
      }
    }
  }
  async openRecruitModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `成为${data.cityName}分桐负责人`,
      description: `报名参与负责人招募，即视为您已自动加入该分桐。待负责人招募工作全部完成后，${data.cityName}分桐将正式开放。`,
      layoutClassName: 'recruit-confirm-modal',
      confirmedHide: true,
      confirmText: '确认',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/recruit-pop-bg.png'
    })

    if (res === true) {
      const res = await this.PageStore.joinGuild(data.id)
      if (res === EnumJoinResponseType.Success) {
        this.onJoinSuccess(data.id)
      } else if (res === EnumJoinResponseType.NoAuth) {
        this.onJoinFail()
      }
    }
  }
  async openJoinModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `${data.cityName}分桐`,
      description: '桐学仅可选择一座常住城市加入，与桐好笔墨相伴，雅会常聚。',
      layoutClassName: 'join-confirm-modal',
      confirmedHide: true,
      confirmText: '确认加入',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png'
    })

    if (res === true) {
      const res = await this.PageStore.joinGuild(data.id)
      if (res === EnumJoinResponseType.Success) {
        this.onJoinSuccess(data.id)
      } else if (res === EnumJoinResponseType.NoAuth) {
        this.onJoinFail()
      }
    }
  }

  toGuildPage(id: number) {
    this.$router.push({
      path: `/topic/city/${id}`
    })
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  handleToIntro() {
    if (this.TonghaoStore.citiesJsonData?.event) {
      this.onClickEvent(this.TonghaoStore.citiesJsonData.event)
      return
    }
  }

  handleCardClick(item: { cover: string; event?: ClickEvent }) {
    if (item.event) {
      this.onClickEvent(item.event)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
